import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { Stack, TextInput } from '@qred/components-library';
import { updateForm } from '~/store/slices/loanOffer.slice';
import { ValidationContext } from '~/components/hoc/withValidation';
import { onChangeInputEvent } from '~/types/types';
import { RootState } from '~/store';
import useTranslate from '~/hooks/useTranslate';
import { validateBankAccountNumber } from '~/helpers/validators.helper';

const AccountNumberInput = () => {
  const dispatch = useAppDispatch();
  const {
    loanOffer: { form },
    intl: { market },
  } = useSelector((state: RootState) => state);
  const validationContext = useContext(ValidationContext);
  const [isTouched, setIsTouched] = useState(false);
  const isMarketSweden = market === 'SE';
  const translate = useTranslate();

  useEffect(() => {
    const hasValidAccountNumber = validateBankAccountNumber(
      form.accountNumber,
      market
    );

    if (!hasValidAccountNumber) {
      validationContext.addPropertyToValidationErrors('InvalidAccountNumber');
    }
    return () => {
      validationContext.removePropertyFromValidationErrors(
        'InvalidAccountNumber'
      );
    };
  }, [form.accountNumber]);

  const onAccountNumberChange = (event: onChangeInputEvent) => {
    const { value } = event.target;
    dispatch(
      updateForm({
        accountNumber: value,
        account: {},
        openBankingAccount: null,
      })
    );
  };

  const accountNumberIsValid = validateBankAccountNumber(
    form.accountNumber,
    market
  );

  return (
    <Stack>
      <TextInput
        value={form.accountNumber || ''}
        onChange={onAccountNumberChange}
        onBlur={() => setIsTouched(true)}
        label={translate('OnboardingOffer.BankAccountInputLabel')}
        hint={
          //TODO: This is a temporary solution to hide the description for the SE market, this should be updated in OB-2669
          !isMarketSweden &&
          translate('OnboardingOffer.BankAccountInputDescription')
        }
        error={
          isTouched &&
          !accountNumberIsValid &&
          translate('ValidationErrors.AccountNumber')
        }
      />
    </Stack>
  );
};

export default AccountNumberInput;
